import { ServiceCodesService } from "./implementations/serviceCodes.service.js";

export default defineNuxtPlugin((nuxtApp) => {
  const servicecodes = new ServiceCodesService(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgApiUrl
  );

  return {
    provide: {
      servicecodes: servicecodes,
    },
  };
});
